import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import it from './it.json';

/**
 * Interfaccia bilingue ITA/ENG per mappatura statica.
 *
 * Qui vivono SOLO le stringhe di interfaccia, incluse le etichette generate dal
 * codice. I contenuti che arrivano dai JSON importati (analisi, temi, evidenze,
 * roadmap) si mostrano nella lingua in cui vengono forniti, in
 * entrambe le versioni dell'interfaccia: non vanno mai tradotti da qui.
 */
export const SUPPORTED_LANGUAGES = ['it', 'en'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

const STORAGE_KEY = 'fametrue.lang';

function initialLanguage(): Language {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'it' || stored === 'en') return stored;
  return navigator.language.toLowerCase().startsWith('en') ? 'en' : 'it';
}

await i18next.use(initReactI18next).init({
  resources: {
    it: { translation: it },
    en: { translation: en },
  },
  lng: initialLanguage(),
  fallbackLng: 'it',
  interpolation: { escapeValue: false },
});

export async function setLanguage(language: Language): Promise<void> {
  localStorage.setItem(STORAGE_KEY, language);
  document.documentElement.lang = language;
  await i18next.changeLanguage(language);
}

document.documentElement.lang = i18next.language;

export default i18next;
